import React, { Component } from "react";

import { Wrapper, Card, Row, Input } from "app/NativeComponents/common";

class AssignLeadSearch extends Component {
  render() {
    return (
      <Card>
        <Row>
          <Input
            ref="lead_search"
            name="lead_search"
            returnKeyType={"search"}
            blurOnSubmit={true}
            autoCorrect={false}
            autoFocus={false}
            keyboardType="default"
            placeholder={"Search Leads"}
            onChange={this.props.updateLeadSearch}
            value={this.props.lead_search}
            type="text"
          />
        </Row>
      </Card>
    );
  }
}

export default AssignLeadSearch;
